import React from 'react';
import _ from 'lodash';
import { useQuery, useParameterizedQuery } from 'react-fetching-library';
import { useSelector } from 'react-redux';

import {
  getSeasonDerivatesAction,
  getResortStatisticsDataAction,
  getDetailCampStatisticsDataAction,
  getDetailEventStatisticsDataAction,
  getResortEvents
} from '../../../services/request';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Typography,
  Stack,
  Divider
} from '@mui/material';
import { ResortStatistics } from './detail_general/ResortStatistics';
import { CampStatistics } from './detail_general/CampStatistics';
import { EventStatistics } from './detail_general/EventStatistics';

export const DetailStatistics = () => {
  const { season } = useSelector(state => state.app);
  const [activeResort, setActiveResort] = React.useState('XR');
  const [activeCamp, setActiveCamp] = React.useState('XC');
  const [activeEvent, setActiveEvent] = React.useState('XE');
  const { loading, payload, error } = useQuery(getSeasonDerivatesAction());
  const resortQuery = useParameterizedQuery(getResortStatisticsDataAction);
  const campQuery = useParameterizedQuery(getDetailCampStatisticsDataAction);
  const eventQuery = useParameterizedQuery(getDetailEventStatisticsDataAction);
  const resortEventsQuery = useParameterizedQuery(getResortEvents);
  const [resorts, setResorts] = React.useState([]);
  const [resortData, setResortData] = React.useState(null);
  const [camps, setCamps] = React.useState([]);
  const [campData, setCampData] = React.useState(null);
  const [events, setEvents] = React.useState([]);
  const [eventData, setEventData] = React.useState(null);

  React.useEffect(() => {
    setActiveResort('XR');
    setResortData(null);
    setActiveCamp('XC');
    setCampData(null);
    setActiveEvent('XE');
    setEventData(null);
  }, [season]);

  React.useEffect(() => {
    if (!error && !loading) {
      setResorts(payload.resorts);
      setCamps(payload.camps);
    }
  }, [loading]);

  const changeResortData = async id => {
    const { payload, error, loading } = await resortQuery.query(id);
    if (!error && !loading) {
      setResortData(payload);
    }
  };

  const changeCampData = async id => {
    const { payload, error, loading } = await campQuery.query(id, activeResort);
    if (!error && !loading) {
      setCampData(payload);
    }
  };

  const changeEventData = async id => {
    const { payload, error, loading } = await eventQuery.query(
      id,
      activeResort
    );
    if (!error && !loading) {
      setEventData(payload);
    }
  };

  const changeEvents = async id => {
    const { payload, error, loading } = await resortEventsQuery.query(id);
    if (!error && !loading) {
      setEvents(payload);
    }
  };

  const handleResortChange = id => {
    setActiveResort(id);
    if (id == 'XR') {
      setResortData(null);

      return;
    }
    handleCampChange('XC');
    handleEventChange('XE');
    changeResortData(id);
    changeEvents(id);
  };

  const handleCampChange = id => {
    setActiveCamp(id);
    handleEventChange('XE');
    if (id == 'XC') {
      setCampData(null);

      return;
    }
    changeCampData(id);
  };

  const handleEventChange = id => {
    setActiveEvent(id);
    if (id == 'XE') {
      setEventData(null);

      return;
    }
    changeEventData(id);
  };

  return (
    <>
      <Card>
        <CardHeader title="Ośrodki" />
        <CardContent>
          <Stack direction="row">
            <Button
              variant={activeResort == 'XR' ? 'contained' : 'outlined'}
              key="XR"
              sx={{ ml: 2, mt: 1 }}
              onClick={() => handleResortChange('XR')}
            >
              X
            </Button>
            {_.map(resorts, obj => (
              <Button
                key={obj.id}
                variant={activeResort == obj.id ? 'contained' : 'outlined'}
                sx={{ ml: 2, mt: 1 }}
                onClick={() => handleResortChange(obj.id)}
              >
                <Typography key={obj.id}>{obj.name}</Typography>
              </Button>
            ))}
          </Stack>
          <Box>
            {resortData ? <ResortStatistics data={resortData} /> : null}
          </Box>
        </CardContent>
      </Card>
      <Divider />
      {activeResort != 'XR' ? (
        <Card>
          <CardHeader
            title={
              activeResort != 'XR'
                ? _.concat(
                  'Turnusy - ',
                  _.filter(resorts, { id: activeResort })[0].name
                )
                : 'Turnusy'
            }
          />
          <CardContent>
            <Stack direction="row" flexWrap="wrap">
              <Button
                variant={activeCamp == 'XC' ? 'contained' : 'outlined'}
                key="XC"
                sx={{ ml: 2, mt: 1 }}
                onClick={() => handleCampChange('XC')}
              >
                X
              </Button>
              {_.map(camps, obj => (
                <Button
                  key={obj.id}
                  variant={activeCamp == obj.id ? 'contained' : 'outlined'}
                  sx={{ ml: 2, mt: 1 }}
                  onClick={() => handleCampChange(obj.id)}
                >
                  <Typography key={obj.id}>{obj.name}</Typography>
                </Button>
              ))}
            </Stack>
            <Box>{campData ? <CampStatistics data={campData} /> : null}</Box>
          </CardContent>
        </Card>
      ) : null}
      <Divider />
      {activeResort != 'XR' ? (
        <Card>
          <CardHeader
            title={
              activeResort != 'XR'
                ? _.concat(
                  'Imprezy - ',
                  _.filter(resorts, { id: activeResort })[0].name
                )
                : 'Imprezy'
            }
          />
          <CardContent>
            <Stack direction="row" flexWrap="wrap">
              <Button
                variant={activeEvent == 'XE' ? 'contained' : 'outlined'}
                key="XE"
                sx={{ ml: 2, mt: 1 }}
                onClick={() => handleEventChange('XE')}
              >
                X
              </Button>
              {_.map(events, obj => (
                <Button
                  key={obj.id}
                  variant={activeEvent == obj.id ? 'contained' : 'outlined'}
                  sx={{ ml: 2, mt: 1 }}
                  onClick={() => handleEventChange(obj.id)}
                >
                  <Typography key={obj.id}>{obj.name}</Typography>
                </Button>
              ))}
            </Stack>
            <Box>{eventData ? <EventStatistics data={eventData} /> : null}</Box>
          </CardContent>
        </Card>
      ) : null}
    </>
  );
};
